"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Paste option
 */
var PasteOption;
(function (PasteOption) {
    /**
     * Paste html with content type "text/html"
     */
    PasteOption[PasteOption["PasteHtml"] = 0] = "PasteHtml";
    /**
     * Paste plain text with content type "text/plain"
     */
    PasteOption[PasteOption["PasteText"] = 1] = "PasteText";
    /**
     * Paste image from clipboard with content type "image/*"
     */
    PasteOption[PasteOption["PasteImage"] = 2] = "PasteImage";
})(PasteOption = exports.PasteOption || (exports.PasteOption = {}));
//# sourceMappingURL=PasteOption.js.map